module.exports = __webpack_public_path__ + "img/ring_r_skip_1_1@2x.b62ba79f.png";